module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-1"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.recipient_id))]), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.item.recipient_type.toLowerCase(),
        params: {
          id: _vm.item.recipient_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [(_vm.item.recipient_type === 'Client') ? _c('a', {
    staticClass: "fa fa-user-circle-o"
  }) : _vm._e(), (_vm.item.recipient_type === 'Driver') ? _c('a', {
    staticClass: "fa fa-drivers-license-o"
  }) : _vm._e()])])], 1), _c('div', {
    staticClass: "columns large-4"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.type))]), _c('div', {
    staticClass: "field"
  }, [_vm._v("sent at: " + _vm._s(_vm.item.date))])]), _c('div', {
    staticClass: "columns large-7"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.getStrippedMessage())), _c('ModalReveal', [_c('a', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("show all")]), _vm._l((_vm.item.message), function(im, k) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "columns flex0"
    }, [_vm._v(_vm._s(k) + ":")]), _c('div', {
      staticClass: "columns"
    }, [_vm._v(_vm._s(im))])])
  })], 2)], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af708c3c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Notification.vue
// module id = 2664
// module chunks = 1